module.exports = __webpack_public_path__ + "media/custom/images/img38-513a0483965a9c3ce820e67e6a34290f.jpg";